import { render, staticRenderFns } from "./Textbox2.vue?vue&type=template&id=f8cdd564&scoped=true&"
import script from "./Textbox2.vue?vue&type=script&lang=js&"
export * from "./Textbox2.vue?vue&type=script&lang=js&"
import style0 from "./Textbox2.vue?vue&type=style&index=0&id=f8cdd564&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8cdd564",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f8cdd564')) {
      api.createRecord('f8cdd564', component.options)
    } else {
      api.reload('f8cdd564', component.options)
    }
    module.hot.accept("./Textbox2.vue?vue&type=template&id=f8cdd564&scoped=true&", function () {
      api.rerender('f8cdd564', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/progressbar/Stamp/components/Textbox2.vue"
export default component.exports